const CouponTypes = {
    GET_COUPONS: "GET_COUPONS",
    GET_COUPONS_SUCCESS: "GET_COUPONS_SUCCESS"
};

export { CouponTypes };